import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import topTitle from '@/components/title';
import { savePersonnelEntry } from '../request';
import { getOccupationResource } from '../../homeManage/request';
import { isCardNo } from '@/utils/validate';
import { getPersonnelDetail } from '../request.js';
import moment from 'moment';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  components: {
    topTitle
  },
  data() {
    return {
      form: {},
      loading: false,
      identificationTypeData: [{
        label: '身份证',
        value: 'IDCARD'
      }],
      defaultValue: moment('00:00:00', 'HH:mm:ss'),
      professionInfo: [{
        id: 1,
        customerInsuranceId: 102,
        jobNumber: 1,
        occupation: '保安',
        transfer: true
      }],
      policyInfo: {},
      yearDays: 365
    };
  },
  computed: {
    rules() {
      return {
        jobNumber: [{
          required: true,
          message: this.$t('请选择') + this.$t('工种'),
          trigger: 'change'
        }],
        identificationType: [{
          required: true,
          message: this.$t('请选择') + this.$t('证件类型'),
          trigger: 'change'
        }],
        name: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('名称')
        }, {
          min: 2,
          max: 15,
          message: this.$t('请输入长度2-15的内容')
        }],
        startAt: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('签约日期')
        }],
        idNumber: [{
          required: true,
          message: this.$t('请输入') + this.$t('证件号码'),
          trigger: 'blur'
        }, {
          validator: this.validateCard,
          trigger: 'blur'
        }]
      };
    }
  },
  watch: {
    dialogVisible: {
      handler(newVal) {
        if (!newVal) return;
        this.form = {};
        this.$refs.dataFrom && this.$refs.dataFrom.resetFields();
        getPersonnelDetail({
          policyId: this.$route.params.id
        }).then(res => {
          if (res.insuranceInfo) {
            this.policyInfo = res.insuranceInfo;
            const {
              policyNo,
              insuranceName,
              startAt,
              endAt,
              planId,
              insurancePlanName,
              customerInsuranceId
            } = this.policyInfo;
            this.getOccupation(customerInsuranceId);
            this.form = {
              policyNo,
              insuranceName,
              beginTime: startAt,
              endTime: endAt,
              planId,
              insurancePlanName,
              startAt: '',
              identificationType: undefined,
              jobNumber: undefined
            };
            if (this.identificationTypeData.length === 1) {
              this.form.identificationType = this.identificationTypeData[0].value;
            }
            if (this.policyInfo.rate && this.policyInfo.rate === 'day') {
              //费率类型为日费率的时候保费除的时候除366
              this.yearDays = 366;
            }
            if (this.policyInfo.declarationMethod === 'DAY') {
              this.setTime(); //日申报自动带出责任起期
            } else {
              this.form.startAt = '';
            }
          }
        });
      }
    }
  },
  methods: {
    validateCard(rule, idcard, callback) {
      if (!isCardNo(idcard) || idcard == '') {
        callback(new Error(this.$t('请输入正确的身份证号')));
      } else {
        callback();
      }
    },
    async getOccupation(customerInsuranceId) {
      //获取工种
      const res = await getOccupationResource({
        customerInsuranceId
      });
      if (res.length > 0) {
        this.professionInfo = res;
      }
      if (this.professionInfo.length === 1) {
        this.$set(this.form, 'jobNumber', this.professionInfo[0].jobNumber);
      }
    },
    setTime() {
      //日申报设置默认的责任起期
      const nowTimeDate = new Date().getTime() + 24 * 60 * 60 * 1000;
      let startTime = moment(new Date(nowTimeDate).setHours(0, 0, 0, 0)).format('YYYY-MM-DD HH:mm:ss');
      this.form.startAt = startTime;
      let endTime = this.policyInfo.endAt;
      this.calcPrice(startTime, endTime, this.policyInfo.premium);
    },
    calcPrice(startTime, endTime, premium) {
      //计算保费
      if (!premium) {
        return;
      }
      let day = (moment(moment(endTime).format('YYYY-MM-DD HH:mm:ss')).unix() * 1000 - moment(startTime).unix() * 1000) / (24 * 60 * 60 * 1000);
      let price = Math.round(Number(premium) * 100 / this.yearDays * Math.ceil(day)) / 100;
      this.form.premium = price;
    },
    onSubmit() {
      this.$refs.dataFrom.validate(valid => {
        if (valid) {
          const {
            jobNumber,
            name,
            identificationType,
            idNumber,
            startAt,
            premium
          } = this.form;
          if (!premium && premium !== 0) {
            this.$message.error(this.$t('保费为空'));
            return;
          }
          let selectOccupation = this.professionInfo.filter(item => item.jobNumber === jobNumber);
          let occupation = selectOccupation.length > 0 ? selectOccupation[0].occupation : '';
          let obj = {
            policyId: this.policyInfo.id,
            jobNumber,
            occupation,
            name,
            identificationType,
            idNumber,
            startAt,
            premium
          };
          this.loading = true;
          savePersonnelEntry(obj).then(res => {
            this.loading = false;
            this.$message.success(this.$t('新增人员成功'));
            this.$emit('refreshList');
            this.$emit('update:dialogVisible', false);
          }).finally(e => {
            this.loading = false;
          });
        }
      });
    },
    onChangeTime(time) {
      if (!time) {
        this.$set(this.form, 'startAt', '');
        this.$set(this.form, 'premium', '');
        return;
      }
      let startAt = moment(time).startOf('day').format('YYYY-MM-DD HH:mm:ss');
      this.$set(this.form, 'startAt', startAt);
      let endTime = this.policyInfo.endAt;
      this.calcPrice(startAt, endTime, this.policyInfo.premium);
    },
    disabledDate(current) {
      let start = moment().subtract(1, 'month').subtract(1, 'day');
      let insuranceStartTime = moment(this.policyInfo.startAt).endOf('day');
      if (insuranceStartTime > start) {
        start = insuranceStartTime;
      }
      let insuranceEndTime = moment(this.policyInfo.endAt).endOf('day');
      let endTime = moment().add(1, 'day').endOf('day');
      if (endTime > insuranceEndTime) {
        endTime = insuranceEndTime;
      }
      return current && current > endTime || current < start;
    },
    cancel() {
      this.$emit('update:dialogVisible', false);
    }
  }
};